<template>
  <div class="project-select-page">
    <!-- 背景装饰 -->
    <div class="ps-bg"></div>
    <div class="ps-grid-bg"></div>
    <div class="ps-orb ps-orb--left"></div>
    <div class="ps-orb ps-orb--right"></div>

    <div class="ps-container">
      <!-- 头部：品牌 + 重新登录 -->
      <header class="ps-header">
        <div class="ps-brand">
          <div class="ps-brand__icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="currentColor" opacity="0.9"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="ps-brand__text">政企实训</span>
        </div>
        <button class="ps-relogin" @click="relogin">
          <i class="el-icon-switch-button"></i>
          <span>重新登录</span>
        </button>
      </header>

      <!-- 标题区 -->
      <div class="ps-title-block">
        <h1>选择项目</h1>
        <p v-if="projectList.length">当前账号关联了 <b>{{ projectList.length }}</b> 个项目，请选择要进入的项目</p>
        <p v-else-if="!loading">暂无可选项目</p>
      </div>

      <!-- 继续进入上次项目（信息来自登录接口返回） -->
      <div v-if="lastProject" class="ps-last-cta" @click="continueLast">
        <div class="ps-last-cta__icon"><i class="el-icon-refresh-right"></i></div>
        <div class="ps-last-cta__body">
          <div class="ps-last-cta__title">继续进入上次项目</div>
          <div class="ps-last-cta__name">{{ lastProject.avOwnerName }}</div>
        </div>
        <i class="el-icon-arrow-right ps-last-cta__arrow"></i>
      </div>

      <!-- 项目卡片网格 -->
      <div v-loading="loading" class="ps-cards">
        <div
          v-for="p in projectList"
          :key="p.avOwnerId"
          class="ps-card"
          :class="{ 'is-last': lastProject && String(lastProject.avOwnerId) === String(p.avOwnerId) }"
          @click="confirmProject(p.avOwnerId)"
        >
          <div class="ps-card__avatar" :style="{ background: avatarColor(p.avOwnerName) }">{{ (p.avOwnerName || '项').slice(0, 1) }}</div>
          <div class="ps-card__body">
            <div class="ps-card__name">{{ p.avOwnerName }}</div>
            <div class="ps-card__meta">
              <span><i class="el-icon-user"></i>{{ p.createusername || '-' }}</span>
              <span><i class="el-icon-time"></i>{{ (p.createtime || '').slice(0, 10) }}</span>
            </div>
          </div>
          <i class="el-icon-arrow-right ps-card__arrow"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getZqsxAuthUserProjectList } from '@/api/api'
import { getLoginPw } from '@/utils/auth'

export default {
  name: 'ProjectSelect',
  data () {
    return {
      loading: false,
      submitting: false,
      projectList: []
    }
  },
  computed: {
    userInfo () { return this.$store.state.user.userInfo || {} },
    // 上次进入的项目：来自登录接口返回的 userInfo.avOwnerId/avOwnerName（当前凭证即对应此项目）
    lastProject () {
      const u = this.userInfo
      if (u && u.avOwnerId != null) {
        return { avOwnerId: u.avOwnerId, avOwnerName: u.avOwnerName || ('项目' + u.avOwnerId) }
      }
      return null
    }
  },
  created () { this.fetchProjects() },
  methods: {
    // 根据项目名 hash 生成头像渐变色
    avatarColor (name) {
      const colors = [
        'linear-gradient(135deg,#1a365d,#2b6cb0)',
        'linear-gradient(135deg,#38a169,#2f855a)',
        'linear-gradient(135deg,#d69e2e,#b7791f)',
        'linear-gradient(135deg,#e53e3e,#c53030)',
        'linear-gradient(135deg,#805ad5,#6b46c1)',
        'linear-gradient(135deg,#319795,#2c7a7b)'
      ]
      const idx = (name || '').split('').reduce((s, c) => s + c.charCodeAt(0), 0) % colors.length
      return colors[idx]
    },
    async fetchProjects () {
      this.loading = true
      try {
        const res = await getZqsxAuthUserProjectList({ currentPage: 1, pageSize: 999 })
        this.projectList = res.data || []
      } catch (e) { this.projectList = [] } finally {
        this.loading = false
      }
    },
    // 选择项目：用暂存密码 + projectId 重新登录换取该项目凭证
    // 注意：projectId 可能为 0（系统管理员系统级项目），不能用 !projectId 判断，否则会误拦
    async confirmProject (projectId) {
      if (projectId == null || this.submitting) return
      const pw = getLoginPw()
      if (!pw) {
        this.$message.warning('登录态已过期，请重新登录')
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
        return
      }
      this.submitting = true
      try {
        await this.$store.dispatch('user/selectProject', {
          zauPhone: this.userInfo.zauPhone,
          zauPw: pw,
          projectId
        })
        this.$message.success('正在进入工作台')
        this.$router.replace('/loading')
      } catch (e) {} finally {
        this.submitting = false
      }
    },
    continueLast () {
      if (!this.lastProject) {
        this.$message.warning('未获取到上次项目信息')
        return
      }
      // 当前凭证已是上次进入的项目，直接进入首页，无需重新登录
      this.$message.success('正在进入工作台')
      this.$router.replace('/loading')
    },
    relogin () {
      this.$store.dispatch('user/logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.project-select-page {
  position: relative;
  min-height: 100vh;
  padding: 28px 32px;
  overflow: hidden;
  background:
    radial-gradient(circle at 14% 18%, rgba(26,54,93,.22), transparent 24%),
    radial-gradient(circle at 88% 16%, rgba(56,161,105,.18), transparent 20%),
    linear-gradient(135deg, #f8fbfd 0%, #edf4f8 42%, #e6f0f4 100%);
}
.ps-bg, .ps-grid-bg, .ps-orb { position: absolute; pointer-events: none; }
.ps-bg {
  inset: -10% -10% auto; height: 300px;
  background:
    radial-gradient(circle at 18% 40%, rgba(26,54,93,.16), transparent 32%),
    radial-gradient(circle at 50% 12%, rgba(255,255,255,.7), transparent 28%),
    radial-gradient(circle at 82% 30%, rgba(56,161,105,.14), transparent 30%);
  filter: blur(14px); opacity: .95;
}
.ps-grid-bg {
  inset: 0;
  background-image:
    linear-gradient(rgba(26,54,93,.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(26,54,93,.05) 1px, transparent 1px);
  background-size: 30px 30px;
  mask-image: radial-gradient(circle at center, #000 42%, transparent 86%);
  opacity: .8;
}
.ps-orb { border-radius: 50%; filter: blur(12px); }
.ps-orb--left { width: 260px; height: 260px; left: -70px; top: 80px; background: radial-gradient(circle, rgba(26,54,93,.2), transparent 68%); }
.ps-orb--right { width: 230px; height: 230px; right: -30px; bottom: 30px; background: radial-gradient(circle, rgba(56,161,105,.16), transparent 70%); }

.ps-container {
  position: relative; z-index: 1;
  max-width: 960px; margin: 0 auto;
  display: flex; flex-direction: column; gap: 18px;
}

.ps-header {
  display: flex; align-items: center; justify-content: space-between;
}
.ps-brand { display: flex; align-items: center; gap: 10px; }
.ps-brand__icon {
  width: 34px; height: 34px;
  background: linear-gradient(135deg, var(--fn-primary), var(--fn-accent));
  border-radius: 9px; display: flex; align-items: center; justify-content: center; color: #fff;
  svg { width: 18px; height: 18px; }
}
.ps-brand__text { font-size: 17px; font-weight: 700; color: #1a365d; letter-spacing: .5px; }

/* 重新登录：精致的次要按钮（半透明玻璃风） */
.ps-relogin {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 6px 12px;
  border: 1px solid rgba(203,213,225,.7);
  border-radius: 8px;
  background: rgba(255,255,255,.55);
  color: #475569;
  font-size: 12px;
  cursor: pointer;
  transition: all .2s;
  backdrop-filter: blur(8px);
  i { font-size: 14px; }
  &:hover {
    background: #fff;
    border-color: #94a3b8;
    color: #334155;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(0,0,0,.06);
  }
}

.ps-title-block {
  text-align: center;
  h1 { margin: 0 0 6px; font-size: 24px; font-weight: 700; color: #1a365d; letter-spacing: 1px; }
  p { margin: 0; font-size: 13px; color: #64748b; b { color: #38a169; } }
}

/* 继续进入上次项目：主色 CTA（缩小） */
.ps-last-cta {
  display: flex; align-items: center; gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(135deg, var(--fn-primary) 0%, #2b6cb0 100%);
  border-radius: 12px;
  cursor: pointer;
  color: #fff;
  box-shadow: 0 6px 16px rgba(26,54,93,.2);
  transition: all .25s cubic-bezier(.4,0,.2,1);
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(26,54,93,.28);
    .ps-last-cta__arrow { transform: translateX(4px); }
  }
}
.ps-last-cta__icon {
  width: 36px; height: 36px; flex-shrink: 0;
  border-radius: 10px;
  background: rgba(255,255,255,.18);
  display: flex; align-items: center; justify-content: center;
  i { font-size: 18px; }
}
.ps-last-cta__body { flex: 1; }
.ps-last-cta__title { font-size: 11px; opacity: .82; margin-bottom: 2px; letter-spacing: .3px; }
.ps-last-cta__name { font-size: 15px; font-weight: 700; }
.ps-last-cta__arrow { transition: transform .2s; font-size: 16px; opacity: .9; }

/* 项目卡片（缩小，无项目ID） */
.ps-cards {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 12px;
  min-height: 120px;
}
.ps-card {
  display: flex; align-items: center; gap: 11px;
  padding: 12px 14px;
  background: rgba(255,255,255,.85);
  border: 1px solid #e2e8f0;
  border-radius: 11px;
  cursor: pointer;
  transition: all .25s cubic-bezier(.4,0,.2,1);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(38,64,92,.05);
  &:hover {
    transform: translateY(-2px);
    border-color: rgba(26,54,93,.28);
    box-shadow: 0 8px 18px rgba(26,54,93,.12);
    .ps-card__arrow { color: var(--fn-primary); transform: translateX(2px); }
  }
  &.is-last {
    border-color: var(--fn-accent);
    box-shadow: 0 4px 12px rgba(56,161,105,.16);
  }
}
.ps-card__avatar {
  width: 40px; height: 40px; flex-shrink: 0;
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 17px; font-weight: 700;
  box-shadow: 0 3px 8px rgba(0,0,0,.12);
}
.ps-card__body { flex: 1; min-width: 0; }
.ps-card__name {
  font-size: 14px; font-weight: 700; color: #1e293b;
  margin-bottom: 4px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.ps-card__meta {
  display: flex; gap: 12px; font-size: 11px; color: #94a3b8;
  span { display: inline-flex; align-items: center; gap: 3px; }
  i { font-size: 12px; }
}
.ps-card__arrow {
  color: #cbd5e1; font-size: 15px;
  transition: all .2s;
}

@media screen and (max-width: 600px) {
  .project-select-page { padding: 18px 16px; }
  .ps-title-block h1 { font-size: 21px; }
}
</style>
